import Header from '../components/Header';
import Footer from '../components/Footer';

/**
 * NoMatch
 *
 * 404 page.
 *
 * @returns {JSX.Element}
 * @constructor
 */
const NoMatch = () => {
  return (
    <div>
      <Header />
      <div className="no-match">
        <h3>Page not found</h3>
      </div>
      <Footer/>
    </div>
  );
}

export default NoMatch;
